"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menus = void 0;
var _xeUtils = _interopRequireDefault(require("xe-utils"));
var _log = require("../../tools/log");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var VXEMenusStore = /*#__PURE__*/function () {
  function VXEMenusStore() {
    _classCallCheck(this, VXEMenusStore);
    this.store = {};
  }
  _createClass(VXEMenusStore, [{
    key: "mixin",
    value: function mixin(options) {
      var _this = this;
      _xeUtils.default.each(options, function (item, key) {
        _this.add(key, item);
      });
      return VXEMenusStore;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this.store[name];
    }
  }, {
    key: "add",
    value: function add(name, render) {
      var conf = this.store[name];
      // 兼容
      if (_xeUtils.default.isFunction(render)) {
        // if (process.env.NODE_ENV === 'development') {
        //   warnLog('vxe.error.delProp', ['menus -> callback', 'menuMethod'])
        // }
        render = {
          menuMethod: render
        };
      }

      // 检测是否覆盖
      if (process.env.NODE_ENV === 'development') {
        var confKeys = _xeUtils.default.keys(conf);
        _xeUtils.default.each(render, function (item, key) {
          if (confKeys.includes(key)) {
            (0, _log.warnLog)('vxe.error.coverProp', [name, key]);
          }
        });
      }
      this.store[name] = conf ? _xeUtils.default.merge(conf, render) : render;
      return VXEMenusStore;
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      delete this.store[name];
      return VXEMenusStore;
    }
  }]);
  return VXEMenusStore;
}();
var menus = new VXEMenusStore();
exports.menus = menus;
if (process.env.NODE_ENV === 'development') {
  Object.assign(menus, {
    _name: 'Menus'
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/v-x-e-table/src/menus.js
// module id = 1027
// module chunks = 75